/**
 * @author ESTECO CSA Team <csa@esteco.com>
 */
export enum IconSize {
    ICON_M = 'a-icon--m',
    ICON_L = 'a-icon--l'
}
